<template>
        <tr class="wbs-row chatter-row" @click="showChatDetail(chatter.chatId, $event)" :class="{'overdue' : isOverdue}">
            <div style="display:flex; height:2.3rem;">
                <td style="display: flex;">
                    {{getDepth()}}
                    <button class="wbs-fold-button" :class="{'show-fold-button': hasChildren}" @click="toggleFolded($event)">
                        <b-icon :icon="isExpanded ? 'caret-down-fill' : 'caret-right-fill'"></b-icon>
                    </button>
                    <!-- <span class="chatter-business-category">
                        {{ getBusinessCategory() }}
                    </span> -->
                    <!-- [{{ chatter.chatId }}] -->
                    <span class="wbs-title">
                        <span v-if="subChatterCount > 0" class="sub-chatter-count">
                            {{ subChatterCount }}
                        </span>
                        {{ chatter.title }}
                    </span>
                    
                </td>
                <td></td>
                <td>
                    <status-badge :status="chatter.status">{{ formatStatusLabel(chatter.status) }}</status-badge>
                </td>
            </div>
            <template v-if="isExpanded" v-for="subChatter in chatter.subChatterList" >
                <chatter-row :chatter="subChatter" :depth="depth + 1" :key="subChatter.chatId"/>
            </template>
        </tr>
</template>
<script>
    import ChatterRow from "@/components/chatter/wbs/ChatterRow.vue";
    import StatusBadge from "./StatusBadge.vue";

    export default {
        name: "ChatterRow",
        props: {
            chatter : { type : Object },
            depth : {type:Number}
        },
        components: {
            ChatterRow,
            StatusBadge
        },
        mounted() {
            this.subChatterCount = this.chatter.subChatterList.length;
        },
        computed: {
            hasChildren() {
                if(!this.chatter.subChatterList) return false;
                return this.chatter.subChatterList.length > 0;
            },
            isExpanded() {
                return this.$store.getters["wbs/getExpanded"](this.chatter.chatId);
            }
        },
        created() {
            this.isOverdue = this.chatter.isOverdue;
        },
        data() {
            return {
                isOverdue : false,
                subChatterCount : 0,
            }
        },
        methods: {
            getOverdue() {
                const dueDate = this.chatter.dueDate;

                const statusArray = ["TO_DO", "IN_PROGRESS"]

                if(dueDate === '') return true;
                if(this.compareDates(this.today, dueDate) > 0 && statusArray.includes(this.chatter.status)) {
                    return true;
                }

                return false;
            },
            getDepth() {

                let depthStr = "";
                for(let i = 0; i < this.depth; i++) {
                    depthStr += '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0';
                }

                return depthStr;
            },
            toggleFolded(event) {
                event.stopPropagation();
                // this.$set(this.chatter, 'expanded', !this.chatter.expanded);
                this.$store.commit("wbs/setExpanded", {id : this.chatter.chatId, isExpanded: !this.isExpanded});
            },
            formatStatusLabel(text) {
                if(!text) return;
                const words = text.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
                return words.join(" ");
            },
            showChatDetail(chatId, event) {
                event.stopPropagation();
                this.$router.push({ name: "chatUpdate", params: { id: chatId } });
            },
            getBusinessCategory(){
                return (this.chatter.businessCategory != null && this.chatter.businessCategory != '') ? '[' + this.chatter.businessCategory + '] ' : '';
            },
        },
        filters: {
            formatDate(dateStr) {
                if(dateStr != '-') {
                    return dateStr.substring(2);
                } else {
                    return dateStr
                }
            }
        }
    }
</script>
<style scoped>
    .chatter-row {
        white-space: nowrap;
    }
    .chatter-row:hover {
        cursor: pointer;
    }
    /* .chatter-row.overdue {
        background-color: #FFDCDC;
    } */
    /* .chatter-row.overdue:hover {
        background-color: #FFC0C0;
    } */
    .chatter-business-category {
        font-size:8pt;
    }
    .wbs-row .sub-chatter-count {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: #2E2E38;
        color: #FDE500;
        margin-right: 0.5rem;
        border-radius: 40px;
        min-width: 1.5rem;
        text-align: center;
        height: 70%;
        padding: 0.2rem 0.3rem;
        font-size: 0.8rem;
        font-weight: bold;
    }
    
    
</style>